<template>
	<div class="row">
		<div class="col-12 mb-4 d-flex flex-row align-items-center flex-wrap">
			<h1>{{ $t("placement-events") }}</h1>

			<button
				class="btn btn-outline-secondary ml-auto mr-2"
				@click="() => { $refs.timetable.scrollToToday() }"
			>
				{{  $t('go-to-current-week') }}
			</button>
			<button
				class="btn mr-2"
				:class="denseView ? 'btn-secondary' : 'btn-outline-secondary'"
				@click="denseView = !denseView"
			>
				{{ denseView ? $t('full-calendar') : $t('back') }}
			</button>
            <button
				class="btn btn-outline-primary mr-2"
				@click="$router.push('/timetables/placement-provider')"
			>
				{{$t('time-report')}}
			</button>
			<button
				:disabled="!placementevents.length || !students.length"
				class="btn btn-primary"
				@click="downloadCSV"
			>
				{{$t('download')}}
			</button>
		</div>

		<template v-if="loaded">
			<AdminTimetable
				v-if="placementevents.length && students.length"
				ref="timetable"
				class="col-12 mb-4"
				:events="placementevents"
				:from="from"
				:until="until"
				:students="students"
				:groups="groups"
				:programme="programme"
				:dense="denseView"
				:allowStudentViewAlways="true"
				:studentViewOnLoad="true"
			/>

			<div v-else class="col-12 mb-4">
				<div class="alert alert-info">{{$t('no-results')}}</div>
			</div>
		</template>
		<template v-else>
			<div class="col-12">
				<div class="skeleton midnight h20 w100 mr-4 mb-3 float-left" v-for="n in 100" :key="n" />
			</div>
		</template>

	</div>
</template>

<script>
import AdminTimetable from 'src/components/Timetables/AdminTimetable.vue';

export default {
	components: {
		AdminTimetable,
	},
	mounted() {
		this.getPlacements()
	},
	data() {
		return {
			submitting: false,
            filters: {
                page: 1,
                page_size: 3000,
                datefrom: '',
                dateto: '',
            },
			placementevents: [],
			loaded: false,
			showselected: null,
			eventContainer: null,
			from: null,
			until: null,
			students: [],
			groups: [],
			programme: null,
			denseView: true,
		}
	},
	methods: {
		getPlacements() {
			this.loaded = false;
			let filters = this.filters
			if (this.$UserSession.hasPriv('TIMETABLE_ADMIN')) {
				filters.provider_id = this.$route.query.provider_id
			}

            this.$cfetch(`${this.$settings.APIBaseURL}/placements/myplacements`, {
				cache: false,
				method: 'GET',
                data: filters,
			}).then(res => {
				if (res.status !== 'SUCCESS') throw new Error('Error fetching placements')

				this.placementevents = res.results
				this.filters.page = res.pagination.page
				this.filters.page_size = res.pagination.page_size
				this.filters.total = res.pagination.total

				const from = this.placementevents.reduce((item, curr) => {
					return item.from < curr.from ? item : curr
				}, this.placementevents[0]).from

				const to = this.placementevents.reduce((item, curr) => {
					return item.to > curr.to ? item : curr
				}, this.placementevents[0]).to

				this.from = new Date(Number(from)*1000).toISOString().split('T')[0]
				this.until = new Date(Number(to)*1000).toISOString().split('T')[0]

				this.processEvents();
				this.loaded = true;
			}).catch(error => {
				this.$log.error.call(this, error)
			})
		},
		processEvents() {
			this.$users.getStudents.call(this).then(users => {
				const usersById = users.reduce((prev, curr) => {
					prev[curr.id] = {
						id: curr.id,
						displayname: curr.displayName,
						programme_id: curr.programme,
						year: curr.year,
						group_id: curr.group,
					}
					return prev
				}, {})

				const students = {}
				const allGroups = {}

				this.placementevents = this.placementevents.map(event => {
					let eventGroups = {}

					event.students = event.students.map(user => {
						let student = usersById[user.id]
						if (!student) return user

						let key = `${student.programme_id}-${student.year}-${student.group_id}`
						let gr = {
							id: key,
							group_id: student.group_id,
							year: student.year,
							title: this.$config.getValue('groups')[student.group_id],
						}

						allGroups[key] = gr
						eventGroups[key] = gr
						students[student.id] = student

						return student
					})

					event.groups = Object.values(eventGroups)
					return event
				})

				this.students = Object.values(students)
				this.groups = Object.values(allGroups)

				if (this.students.length) this.programme = this.$config.getValue('programmes')[this.students[0].programme_id]
			})
		},
        toPage(pageNo) {
            this.filters.page = pageNo
            this.getPlacements()
        },
		downloadCSV() {
			const csv = 'data:text/csv;charset=utf-8,' + this.$refs.timetable.eventContainer.getCSV(this.students)

			const el = document.createElement('a')
			el.href = csv
			el.setAttribute('download', 'placements.csv')
			el.click()
		},
		downloadPlacements(){
			window.open(
				`${this.$settings.APIBaseURL}/placements/myplacements?username=${this.$UserSession.getValue.call(
					this,
					"username"
				)}&authToken=${this.$UserSession.getValue.call(
					this,
					"authToken"
				)}&download=pdf`
			);
		}
	},
};
</script>
